interface ClaimLabState {
  connectorName: string | null
  claim: Record<string, unknown> | null
}

export const useClaimLabState = () =>
  useState<ClaimLabState>('claimLab', () => ({
    connectorName: null,
    claim: null,
  }))
